import React from "react";
import Header from "./Header";
import { BS_BASE } from "./configs/api";
import { authHeader } from "./helpers/auth-header";
import { max } from "rxjs";
import { useNavigate } from "react-router-dom"; // ADD

function formatDMY(date) {
  const d = String(date.getDate()).padStart(2, "0");
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const y = date.getFullYear();
  return `${d}/${m}/${y}`;
}

export default function RegularSchedule() {
  const navigate = useNavigate(); // ADD

  const [clients, setClients] = React.useState([]);
  const [clientId, setClientId] = React.useState("");
  const [loadingClients, setLoadingClients] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");
  const [items, setItems] = React.useState([]);
  // NEW: Max Per Week selection
  const [maxPerWeek, setMaxPerWeek] = React.useState("");
  // NEW: Max Per Day selection
  const [maxPerDay, setMaxPerDay] = React.useState("");

  // NEW: 5 priority availability slots (day + start + end)
  const weekdays = React.useMemo(
    () => [
      { value: "", label: "Select Day" },
      { value: "Monday", label: "Monday" },
      { value: "Tuesday", label: "Tuesday" },
      { value: "Wednesday", label: "Wednesday" },
      { value: "Thursday", label: "Thursday" },
      { value: "Friday", label: "Friday" },
      { value: "Saturday", label: "Saturday" },
      { value: "Sunday", label: "Sun" }
    ],
    []
  );
  const [slots, setSlots] = React.useState(
    Array.from({ length: 5 }, () => ({ day: "", start: "", end: "" }))
  );

  // NEW: submit state
  const [submitting, setSubmitting] = React.useState(false);

  function updateSlot(index, field, value) {
    setSlots((prev) => {
      const next = [...prev];
      next[index] = { ...next[index], [field]: value };
      return next;
    });
  }
  function clearSlot(index) {
    setSlots((prev) => {
      const next = [...prev];
      next[index] = { day: "", start: "", end: "" };
      return next;
    });
  }

  // NEW: submit handler to send JSON to regular-schedule endpoint
  async function handleSubmitSchedule() {
    // Basic validation
     //check client is slected
      if (!clientId) {
        window.alert("Please select a client.");
        setSubmitting(false);
        return;
      }
      //check maxPerWeek is selected
      if (!maxPerWeek) {
        window.alert("Please select Max Per Week.");
        setSubmitting(false);
        return;
      }
      //check maxPerDay is selected
      if (!maxPerDay) {
        window.alert("Please select Max Per Day.");
        setSubmitting(false);
        return;
      }
  
    // Only keep slots where both HH and MM are selected for start and end
    const timeComplete = (t) => {
      const [h = "", m = ""] = String(t).split(":");
      return h.length === 2 && m.length === 2;
    };

    const cleanSlots = slots
      .map((s, i) => ({
        priority: i + 1,
        day: s.day,
        start: s.start,
        end: s.end
      }))
      .filter((s) => s.day && timeComplete(s.start) && timeComplete(s.end));

    if (cleanSlots.length === 0) {
      window.alert("Please add at least one availability slot (day, start and end).");
      return;
    }

    // Validate time order (HH:mm strings are zero-padded by <input type="time"/>)
    const toMinutes = (t) => {
      const parts = String(t).split(":");
      const h = parseInt(parts[0], 10) || 0;
      const m = parseInt(parts[1], 10) || 0;
      return h * 60 + m;
    };
    const invalid = cleanSlots.find((s) => toMinutes(s.start) >= toMinutes(s.end));
    if (invalid) {
      window.alert("Each slot start time must be before its end time.");
      return;
    }

    const payload = {
      clientId: Number(clientId),
      maxPerWeek: maxPerWeek ? Number(maxPerWeek) : null,
      maxPerDay: maxPerDay ? Number(maxPerDay) : null,
      slot: cleanSlots
    };

    try {
      setSubmitting(true);
      const res = await fetch(`${BS_BASE}/regular-schedule`, {
        method: "POST",
        headers: { "Content-Type": "application/json", ...authHeader() },
        body: JSON.stringify(payload)
      });
      if (!res.ok) {
        const text = await res.text().catch(() => "");
        throw new Error(text || `HTTP ${res.status}`);
      }
      window.alert("Regular schedule saved.");
      navigate("/admin-dashboard"); // GO BACK AFTER OK
    } catch (e) {
      window.alert(`Failed to save regular schedule: ${e instanceof Error ? e.message : String(e)}`);
    } finally {
      setSubmitting(false);
    }
  }

  React.useEffect(() => {
    let ignore = false;
    async function loadClients() {
      setLoadingClients(true);
      setError("");
      try {
        const res = await fetch(`${BS_BASE}/clients`, {
          headers: { Accept: "application/json", ...authHeader() }
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        if (!ignore) {
          const list = Array.isArray(data) ? data : (Array.isArray(data && data.items) ? data.items : []);
          // Show firstName + lastName for each client
          const normalized = list
            .map((c) => {
              const id =
                c.ID != null
                  ? c.ID
                  : c.id != null
                  ? c.id
                  : c.clientId != null
                  ? c.clientId
                  : c.userId;
              const name = [c.firstName, c.lastName].filter(Boolean).join(" ");
              return { id, name };
            })
            .filter((c) => c.id != null && c.name !== "");
          setClients(normalized);
        }
      } catch (e) {
        if (!ignore) setError(e instanceof Error ? e.message : String(e));
      } finally {
        if (!ignore) setLoadingClients(false);
      }
    }
    loadClients();
    return () => { ignore = true; };
  }, []);

  /*const fetchClientSchedule = React.useCallback(async (id) => {
    if (!id) return;
    setLoading(true);
    setError("");
    try {
      const start = new Date();
      start.setHours(0, 0, 0, 0);
      const end = new Date(start);
      end.setDate(end.getDate() + 42); // default: today + 6 weeks

      const startStr = formatDMY(start);
      const endStr = formatDMY(end);

      // Uses bookings-by-range with clientId filter (adjust if your API differs)
      const res = await fetch(
        `${BS_BASE}/bookings-by-range?StartDate=${encodeURIComponent(startStr)}&EndDate=${encodeURIComponent(endStr)}&clientId=${encodeURIComponent(id)}`,
        { headers: { Accept: "application/json", ...authHeader() } }
      );
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      const list = Array.isArray(data) ? data : (Array.isArray(data?.items) ? data.items : []);
      const normalized = list.map(b => ({
        id: b.id,
        date: b.date || b.day,
        start: String(b.startTime || "").slice(0, 5),
        end: String(b.endTime || "").slice(0, 5),
        type: b.type,
        accepted: b.accepted
      }));
      setItems(normalized);
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, []);

  React.useEffect(() => {
    if (clientId) fetchClientSchedule(clientId);
  }, [clientId, fetchClientSchedule]);*/

  // Force 15‑minute increments cross‑browser by using dropdowns
  const hourOptions = React.useMemo(
    () => Array.from({ length: 14 }, (_, i) => String(i + 7).padStart(2, "0")), // 07..20
    []
  );
  const minuteOptions15 = React.useMemo(() => ["00", "15", "30", "45"], []);

  // Smaller select style for slot dropdowns (about 50% of original padding/font)
  const SLOT_SELECT_STYLE = {
    padding: "4px 5px",
    fontSize: "0.8rem",
    borderRadius: 6,
    border: "1px solid #ddd",
    backgroundColor: "#fff",
    position: "relative",
    zIndex: 2,
    pointerEvents: "auto",
    WebkitAppearance: "menulist", // Safari: ensure native dropdown
    MozAppearance: "menulist",
    appearance: "menulist"
  };

  function updateSlotTime(index, key, hourOrNull, minuteOrNull) {
    setSlots((prev) => {
      const next = [...prev];
      const current = next[index][key] || "";
      const [h = "", m = ""] = current.includes(":") ? current.split(":") : ["", ""];
      const hour = hourOrNull !== null ? hourOrNull : h;
      const minute = minuteOrNull !== null ? minuteOrNull : m;
      // Keep partial selection so the dropdown shows the chosen HH or MM
      next[index] = { ...next[index], [key]: `${hour || ""}:${minute || ""}` };
      return next;
    });
  }

  return (
    <div className="bookingform-page" style={{ minHeight: "100vh" }}>
      <div className="bookingform-form main-container" style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <Header onBack={() => window.history.back()} />
        <h2 style={{ margin: "6px 0 8px" }}>Regular Schedule</h2>

        <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
          <label htmlFor="clientSelect" style={{ fontWeight: 700 }}>Client</label>
          <select
            id="clientSelect"
            value={clientId}
            onChange={(e) => setClientId(e.target.value)}
            disabled={loadingClients}
            style={{ padding: "8px 10px", borderRadius: 8, border: "1px solid #ddd", minWidth: 220 }}
          >
            <option value="">{loadingClients ? "Loading clients…" : "Select a client"}</option>
            {clients.map(c => (
              <option key={c.id} value={c.id}>{c.name}</option>
            ))}
          </select>
        </div>

        {/* NEW: Max Per Week */}
        <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", marginTop: 6 }}>
          <label htmlFor="maxPerWeek" style={{ fontWeight: 700 }}>Max Per Week</label>
          <select
            id="maxPerWeek"
            value={maxPerWeek}
            onChange={(e) => setMaxPerWeek(e.target.value)}
            style={{ padding: "8px 10px", borderRadius: 8, border: "1px solid #ddd", minWidth: 220 }}
          >
            <option value="">Select Lessons per week</option>
            {[1,2,3,4,5].map(n => (
              <option key={n} value={n}>{n}</option>
            ))}
          </select>
        </div>

        {/* NEW: Max Per Day on a new line */}
        <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", marginTop: 6 }}>
          <label htmlFor="maxPerDay" style={{ fontWeight: 700 }}>Max Per Day</label>
          <select
            id="maxPerDay"
            value={maxPerDay}
            onChange={(e) => setMaxPerDay(e.target.value)}
            style={{ padding: "8px 10px", borderRadius: 8, border: "1px solid #ddd", minWidth: 160 }}
          >
            <option value="">Select per day</option>
            {[1,2,3,4,5].map(n => (
              <option key={n} value={n}>{n}</option>
            ))}
          </select>
        </div>

        {/* NEW: Availability Slots (Priority 1–5) */}
        <div
          style={{
            marginTop: 12,
            border: "1px solid #e5e5e5",
            borderRadius: 10,
            background: "#fafafa",
            padding: 12
          }}
        >
          <div style={{ fontWeight: 700, marginBottom: 8, color: "#1976d2" }}>
            Availability (Priority Order)
          </div>
          <div style={{ display: "grid", gap: 10 }}>
            {slots.map((slot, idx) => (
              <div
                key={idx}
                style={{
                  display: "grid",
                  gridTemplateColumns: "110px 1fr 1fr auto",
                  gap: 8,
                  alignItems: "center"
                }}
              >
                {/* <div style={{ fontWeight: 700 }}>Priority {idx + 1}</div> */}

                <select
                  value={slot.day}
                  onChange={(e) => updateSlot(idx, "day", e.target.value)}
                  style={SLOT_SELECT_STYLE}
                >
                  {weekdays.map((d) => (
                    <option key={d.value || `empty-${idx}`} value={d.value}>{d.label}</option>
                  ))}
                </select>

                {/* REPLACE time inputs with hour/minute dropdowns (15‑min increments) */}
                <div style={{ display: "flex", gap: 6, flexWrap: "nowrap" }}>
                  {(() => {
                    const [sh = "", sm = ""] = slot.start ? slot.start.split(":") : ["", ""];
                    return (
                      <>
                        <select
                          value={sh}
                          onChange={(e) => updateSlotTime(idx, "start", e.target.value, null)}
                          style={SLOT_SELECT_STYLE}
                          aria-label="Start hour"
                          tabIndex={0}
                        >
                          <option value="">HH</option>
                          {hourOptions.map((h) => (
                            <option key={`sh-${idx}-${h}`} value={h}>{h}</option>
                          ))}
                        </select>
                        <span style={{ alignSelf: "center", color: "#666" }}>:</span>
                        <select
                          value={sm}
                          onChange={(e) => updateSlotTime(idx, "start", null, e.target.value)}
                          style={SLOT_SELECT_STYLE}
                          aria-label="Start minutes"
                          tabIndex={0}
                        >
                          <option value="">MM</option>
                          {minuteOptions15.map((m) => (
                            <option key={`sm-${idx}-${m}`} value={m}>{m}</option>
                          ))}
                        </select>
                      </>
                    );
                  })()}

                  <span style={{ alignSelf: "center", color: "#666", marginInline: 1, whiteSpace: "nowrap" }}>to</span>

                  {(() => {
                    const [eh = "", em = ""] = slot.end ? slot.end.split(":") : ["", ""];
                    return (
                      <>
                        <select
                          value={eh}
                          onChange={(e) => updateSlotTime(idx, "end", e.target.value, null)}
                          style={SLOT_SELECT_STYLE}
                          aria-label="End hour"
                          tabIndex={0}
                        >
                          <option value="">HH</option>
                          {hourOptions.map((h) => (
                            <option key={`eh-${idx}-${h}`} value={h}>{h}</option>
                          ))}
                        </select>
                        <span style={{ alignSelf: "center", color: "#666" }}>:</span>
                        <select
                          value={em}
                          onChange={(e) => updateSlotTime(idx, "end", null, e.target.value)}
                          style={SLOT_SELECT_STYLE}
                          aria-label="End minutes"
                          tabIndex={0}
                        >
                          <option value="">MM</option>
                          {minuteOptions15.map((m) => (
                            <option key={`em-${idx}-${m}`} value={m}>{m}</option>
                          ))}
                        </select>
                      </>
                    );
                  })()}
                </div>

               
              </div>
            ))}
          </div>
          <div style={{ marginTop: 8, color: "#666", fontSize: 12 }}>
            Tip: Leave unused priority rows blank.
          </div>
        </div>

        {error && <div style={{ color: "crimson", fontSize: 13 }}>Error: {error}</div>}

        {/* Submit button */}
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 14 }}>
          <button
            type="button"
            onClick={handleSubmitSchedule}
            disabled={submitting || !clientId}
            style={{
              background: "#1976d2",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              padding: "10px 16px",
              fontWeight: 700,
              cursor: submitting || !clientId ? "not-allowed" : "pointer",
              opacity: submitting || !clientId ? 0.7 : 1
            }}
          >
            {submitting ? "Saving…" : "Submit"}
          </button>
        </div>

        {/* ...existing commented-out schedule preview/list... */}
      </div>
    </div>
  );
}